module.exports = __webpack_public_path__ + "fonts/Oswald-Regular.69e9fbd.woff2";